import React from 'react';
import { Box, Typography } from '@mui/material';
import { PaginationComponent } from '../PaginationComponent';

// Pie de las tablas de listado — ver los .dc.html del handoff:
// "Mostrando 1–10 de N x" a la izquierda y la paginacion a la derecha,
// separados del cuerpo por un borde superior.
const ListFooter = ({ data, currentCount, indexFirst, paginate, itemsperPage, noun }) => (
	<Box
		sx={{
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'space-between',
			padding: '16px 22px',
			borderTop: '1px solid',
			borderColor: 'divider',
			flexWrap: 'wrap',
			gap: '10px'
		}}
	>
		<Typography sx={{ fontSize: 13, color: 'text.disabled' }}>
			Mostrando{' '}
			<strong>
				{data.length === 0 ? 0 : indexFirst + 1}–{indexFirst + currentCount}
			</strong>{' '}
			de {data.length} {noun}
		</Typography>
		<PaginationComponent data={data} paginate={paginate} itemsperPage={itemsperPage} />
	</Box>
);

export default ListFooter;
